<div class="class-wrapper">
  <app-status-messages
    [msgs]="msgs"
    [btnLabel]="btnLabel"
    [continueType]="continueType"
    (targetAction)="handleIncomingAction($event)"
  ></app-status-messages>
  <div class="modal-header text-center">
    <h4 class="modal-title w-100 font-weight-bold">{{ mode }} Room</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="manageRoomModal.hide()"
      id="close-modal-icon"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body m-3 p-0">
    <div class="row flex-edit-form">
      <form
        class="text-center border border-light p-5 edit-form w-100"
        [formGroup]="roomForm"
        (ngSubmit)="manageRoom()"
        autocomplete="off"
      >
        <div class="md-form mb-5 form-group">
          <input
            type="text"
            id="room_name"
            formControlName="room_name"
            class="form-control"
            mdbInput
          />
          <label for="room_name">Room Name</label>
          <small id="room_name" class="form-text text-muted mb-4">
            Room name is limited to 50 characters
          </small>
        </div>
        <div class="md-form mb-5 form-group">
          <input
            type="text"
            id="room_description"
            formControlName="room_description"
            class="form-control"
            mdbInput
          />
          <label for="room_description">Room Description</label>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button
      mdbBtn
      class="waves-light theme-action-button"
      mdbWavesEffect
      (click)="manageRoomModal.hide()"
      id="close-modal-btn"
    >
      Close
    </button>
    <button
      mdbBtn
      class="waves-light theme-action-button"
      mdbWavesEffect
      (click)="manageRoom()"
      id="action-room-btn"
    >
      {{ mode }} Room
    </button>
  </div>
</div>
